import { camelCase, size } from "lodash";
import { parsePhoneNumber } from "react-phone-number-input";
import { push } from "@lagunovsky/redux-react-router";
import { split } from "lodash";
import { useLocation } from "react-router-dom";

import { Column, Container, Row, Separator, TextDisplay } from "src/styled";
import { createErrorNotification, createSuccessNotification, translate } from "src/services";
import { RightDisplayPanel } from "src/components";
import { sendCode, setEmail, setPhone } from "src/redux/reducers";
import { useAppDispatch } from "src/redux/store";
import BulkyBGImage from "src/assets/images/bulky_bg_1.jpg";
import RequestCodeForm, { LoginFormValues } from "./RequestCodeForm";
import RubiconLogo from "src/assets/svg/RubiconLogoPrimary.svg";

const RequestCodePage = () => {
  const dispatch = useAppDispatch();

  const { pathname } = useLocation();
  const vendorFromUrl = split(pathname, "/")[1];

  const sendCodeSubmit = (values: LoginFormValues) => {
    if (vendorFromUrl) {
      const phone =
        size(values.phone) > 2 ? (parsePhoneNumber(values.phone)?.number || "").toString() : "";

      sendCode({ ...values, phone, vendorUrl: vendorFromUrl })(dispatch)
        .then((data) => {
          const { codeWasSent } = data;
          if (codeWasSent) {
            createSuccessNotification(
              translate("alertMessages.codeWasSentTo", {
                destination: phone || values.email,
              })
            )(dispatch);

            // save the email and phone in the store for later use
            if (phone) dispatch(setPhone(phone));
            if (values.email) dispatch(setEmail(values.email));

            dispatch(push(`/${vendorFromUrl}/validate`));
          } else {
            createErrorNotification(translate("alertMessages.generalError"))(dispatch);
          }
        })
        .catch((error) => {
          createErrorNotification(
            translate(
              error && error.response.data && error.response.data.code
                ? translate(`alertMessages.${camelCase(error.response.data.code)}`)
                : translate("alertMessages.generalError")
            )
          )(dispatch);
        });
    }
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Column lg={6} padding="no medium">
            <Separator height={120} />
            <TextDisplay
              size="xLarge"
              block
              align="center"
              weight="medium"
              margin="large no no"
              desktopMargin="xxLarge no no"
            >
              {translate("loginPage.heading")} {vendorFromUrl}
            </TextDisplay>
            <TextDisplay
              size="medium"
              block
              align="center"
              margin="xSmall no no"
              desktopMargin="medium no no"
            >
              {translate("loginPage.subHeading")}
            </TextDisplay>
            <Separator height={110} />
            <RequestCodeForm onSubmit={sendCodeSubmit} />
          </Column>
        </Row>
      </Container>
      <RightDisplayPanel backgroundImage={BulkyBGImage} bottomLogo={RubiconLogo}>
        <TextDisplay size="extraLarge" color="white" weight="medium">
          {translate("bannerContent.sayGoodbyToBulkyItems")}
        </TextDisplay>
        <TextDisplay
          size="large"
          color="grayDark"
          margin="sMedium no no"
          desktopMargin="medium no no"
        >
          {translate("bannerContent.makeLifeEasier")}
        </TextDisplay>
        <TextDisplay
          size="large"
          color="grayDark"
          margin="sMedium no no"
          desktopMargin="medium no no"
        >
          {translate("bannerContent.ourSolution")}
        </TextDisplay>
      </RightDisplayPanel>
    </>
  );
};

export default RequestCodePage;
